// The IMEI printed under the barcode on a device label: exactly 15 digits
const IMEI_LENGTH = 15
const digitsOnly = /^\d+$/

export const isImei = (value: string): boolean =>
  value.length === IMEI_LENGTH && digitsOnly.test(value)
